import React from "react";
import { Grid } from "@material-ui/core";

function FormFields({ fields }) {
  return (
    <Grid container spacing={1}>
      {fields.map(
        (item, idx) =>
          !item.hidden && (
            <Grid item xs={item.size} key={idx}>
              {item.field}
            </Grid>
          )
      )}
    </Grid>
  );
}

export default FormFields;
